import { ChartsTooltipContainer, useAxesTooltip } from "@mui/x-charts";

import {
  CategorySwatch,
  TooltipBox,
  TooltipLabel,
  TooltipRow,
  TooltipTitle,
  TooltipValue,
} from "./styles";

// Axis tooltip that only lists series with a value at the hovered bucket.
// The chart splits income/expense into selected + context bars (one of each
// pair is always null), so the default tooltip renders blank rows — this
// filters those out before rendering.
export const CashflowTooltip: React.FC = () => {
  const tooltipData = useAxesTooltip();

  if (!tooltipData || tooltipData.length === 0) {
    return null;
  }

  const axis = tooltipData[0];
  const items = axis.seriesItems.filter((item) => item.value != null);

  if (items.length === 0) {
    return null;
  }

  return (
    <ChartsTooltipContainer trigger="axis">
      <TooltipBox>
        <TooltipTitle>{axis.axisFormattedValue}</TooltipTitle>
        {items.map((item) => (
          <TooltipRow key={item.seriesId}>
            <CategorySwatch $color={item.color} />
            <TooltipLabel>{item.formattedLabel}</TooltipLabel>
            <TooltipValue>{item.formattedValue}</TooltipValue>
          </TooltipRow>
        ))}
      </TooltipBox>
    </ChartsTooltipContainer>
  );
};
